// 请求价格
import $jsonp from './ajax.js'
import Decimal from "./../utils/Decimal";
import toFixed from "./../utils/toFixed.js";




function getPriceRequest(data, callBack) {
	// 拼接传给接口的参数
	var paramTemp = window.commercial;
	// console.log('paramTemp', paramTemp)
	var param = {
		productId: 100,
		entityId: paramTemp.entityidlist,
		entityType: paramTemp.entitytype,
		source: paramTemp.common.source,
		media: 0
	};

	param.hours = data.hours;
	param.pageList = data.pageList;
	// 优惠券码，不传默认为空
	param.couponCode = data.couponCode || '';
	// 账户资金
	var accountBalance = data.accountBalance;
	// 默认选中的天数对应的时长折扣
	var defaultDiscount = data.defaultDiscount;
	// 传给后端的时间戳id值，后端会在接口中返回，当传入值和返回值相同时进行后续操作
	param.v = new Date().getTime();
	$jsonp('//infotophttpapi.58.com/infoTop/calPrice', param, function(result) {
		// console.log('result', result)

		if(param.v != result.data.version) { return; }

		// 单个的价格请求计算
		// let price = {initial:[], discountPrice:[]};
		let price = {};
		if(result.data.price.length==1 && result.data.price[0] != null){
			price = formatPrice(result.data.price[0], accountBalance);
		}


		// 当返回多组价格时（初始化请求）
		if(result.data.price.length > 1) {
			let priceTemp = {}
			let initial = [];
			for(let i = 0; i < result.data.price.length; i++) {
				let priceItem = result.data.price[i];
				if(priceItem != null) {
					// 默认天数的价格计算
					if(priceItem.timeDiscounts.discount == defaultDiscount) {
						priceTemp = formatPrice(priceItem, accountBalance);
					}

					// 初始化每一组的价格和时长折扣价，用于详情页渲染每一天上面的价格
					initial.push({
						hidden_totalPrice: toFixed(new Decimal(priceItem.initialPrice)),
						discountPrice: toFixed(new Decimal(priceItem.timeDiscounts.privilege))
					})
				}
			}

			priceTemp.initial = initial;
			price = $.extend({},priceTemp);
		}

		// console.log('price', price)

		// 满足条件直接调用回调函数
		callBack(price)
	})
}

// 计算处理单个价格
function formatPrice(priceAlone, accountBalance) {
	let result = {discountPrice:[]}
	let discountTotal = 0;
	for(var item in priceAlone) {
		var priceItme = priceAlone[item];
		if(typeof priceItme!="number" && typeof priceItme!="string"&&priceItme.order){
			result.discountPrice[priceItme.order-1] = {
				name:priceItme.name,
				price:toFixed(new Decimal(priceItme.privilege)),
				discount:priceItme.discount
			}

			discountTotal = new Decimal(priceItme.privilege).add(discountTotal)
		}
	}

	// 预计需要的价格
	// hidden_totalPrice: 减去时长折扣，阶梯定价的价格，即费用总计
	// reval_totalPrice: 减去时长折扣和阶梯折扣的价格和限时特惠的价格
	// realPrice: 不减账户余额的价格，即实付金额
	// payPrice: 需要充值的价格
	// couponPrice: 需要传给优惠券接口的价格

	// 费用总计
	result.hidden_totalPrice = toFixed(new Decimal(priceAlone.initialPrice));

	// 减去限时特惠之后的费用总计（用于发布页的总计金额和应付金额）
	// result.reval_totalPrice = toFixed(new Decimal(priceAlone.initialPrice).sub(priceAlone.priceDiscounts.privilege));

	// 实付金额
	result.realPrice = toFixed(new Decimal(priceAlone.totalPrice));

	// 需要充值的金额
	result.payPrice = toFixed(new Decimal(priceAlone.totalPrice).sub(accountBalance))

	// 需要传给优惠券的金额
	// initialPrice中已经减过时长折扣了，discountTotal中也包括时长折扣，所以这里时长折扣再加回来一个
	result.couponPrice = new Decimal(priceAlone.initialPrice).sub(discountTotal).add(priceAlone.timeDiscounts.privilege).div(100).toString().match(/\d*\.?\d{0,2}/g)[0];

	// 用于展示的优惠券抵扣价格
	result.couponDisPrice = toFixed(new Decimal(priceAlone.couponDiscounts.privilege));

	// 账户资金，详情页新余额需要展示
	result.accountBalance = toFixed(accountBalance);

	// 房产增加会员专享价显示
	result.afterVipPrice = priceAlone.afterVipPrice ? toFixed(new Decimal(priceAlone.afterVipPrice)) : false;

	return result;
}

export default getPriceRequest;

